/**
 * Nutrition readiness -> where the user goes next.
 *
 * The backend (GET /profile/nutrition-readiness) is the ONE definition of WHY
 * nutrition isn't ready (`next_step`); this file only maps that answer to a
 * Settings section and the prompt's wording, so PlanningHub, the setup prompt
 * and Settings can't disagree about what is missing.
 */

// Required profile inputs -> the Settings section that edits them
var FIELD_SECTION = {
  age: 'body',
  sex: 'body',
  height: 'body',
  weight: 'body',
  activity_level: 'activity',
};

/** True for a well-formed readiness answer. */
export function isReadiness(value) {
  return !!value && typeof value.next_step === 'string';
}

/** The Settings section a readiness answer should open, or null. */
export function settingsSectionFor(readiness) {
  if (!isReadiness(readiness)) return null;
  switch (readiness.next_step) {
    case 'goal':
      return 'goal';
    case 'macros':
      return 'macros';
    case 'profile': {
      var fields = readiness.missing_profile_fields || [];
      for (var i = 0; i < fields.length; i++) {
        if (FIELD_SECTION[fields[i]]) return FIELD_SECTION[fields[i]];
      }
      return 'body';
    }
    default:
      return null;
  }
}

/** Prompt wording for a genuine setup step (goal / profile / macros). */
export function setupCopyFor(readiness) {
  var step = isReadiness(readiness) ? readiness.next_step : null;
  if (step === 'goal') {
    return { title: 'Choose your goal', body: 'Pick a goal so Fitxess can personalize your plan and progress.' };
  }
  if (step === 'profile') {
    return { title: 'Finish your profile', body: 'Add the details Fitxess needs to calculate your nutrition targets.' };
  }
  if (step === 'macros') {
    return { title: 'Set your macro targets', body: 'Enter your calorie and macro targets to personalize your plan.' };
  }
  return null;
}
